export default __webpack_public_path__ + "static/media/Corn.2be72493.jpg";